import { primitiveColorTokens } from '@cellula/react-theme-patient';

export function BrandedIllustrationDevices() {
	return (
		<svg viewBox='0 0 400 256' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect stroke='none' x='170' y='219' width='83' height='13' rx='6.5' fill={primitiveColorTokens.primary['600']} />
			<path
				stroke='none'
				d='M233 191H190V215H176.5C172.91 215 170 217.91 170 221.5C170 225.09 172.91 228 176.5 228H246.5C250.09 228 253 225.09 253 221.5C253 217.91 250.09 215 246.5 215H233V191Z'
				fill={primitiveColorTokens.primary['500']}
			/>
			<rect stroke='none' x='98' y='28' width='226' height='169' rx='16' fill={primitiveColorTokens.primary['600']} />
			<rect stroke='none' x='98' y='24' width='226' height='169' rx='16' fill={primitiveColorTokens.primary['500']} />
			<path
				stroke='none'
				d='M98 40C98 31.1634 105.163 24 114 24H308C316.837 24 324 31.1634 324 40V160H98V40Z'
				fill={primitiveColorTokens.primary['800']}
			/>
			<rect stroke='none' x='110' y='36' width='202' height='112' rx='8' fill={primitiveColorTokens.primary['400']} />
			<circle stroke='none' cx='211.5' cy='176.5' r='6.5' fill={primitiveColorTokens.primary['600']} />
			<rect stroke='none' x='75' y='95' width='79' height='136' rx='16' fill={primitiveColorTokens.primary['600']} />
			<rect stroke='none' x='75' y='91' width='79' height='136' rx='16' fill={primitiveColorTokens.primary['700']} />
			<rect stroke='none' x='85' y='113' width='59' height='92' rx='8' fill={primitiveColorTokens.primary['400']} />
			<circle stroke='none' cx='114.5' cy='215.5' r='6.5' fill={primitiveColorTokens.primary['600']} />
			<rect stroke='none' x='102' y='99' width='25' height='7' rx='3.5' fill={primitiveColorTokens.primary['900']} />
		</svg>
	);
}
